import { useQuery } from '@tanstack/react-query';

import fetchBlocks from 'api/block/fetchBlocks';
import API_END_POINT from 'constants/apiEndPoints';
import { Framework } from 'types';

interface UseBlocksParams {
  framework?: Framework;
  frameworkVersion?: string;
}

const useBlocks = ({ framework, frameworkVersion }: UseBlocksParams) => {
  const blocksQueryData = useQuery({
    queryKey: [API_END_POINT.BLOCK.FETCH_BLOCKS, framework, frameworkVersion],
    queryFn: () => fetchBlocks({ framework: framework!, frameworkVersion: frameworkVersion! }),
    enabled: !!framework && !!frameworkVersion,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return blocksQueryData;
};

export default useBlocks;
